import styles from './index.scss'
import classnames from 'classnames'

type PropsType = {
  children: any
  style?: React.CSSProperties
  bgType?: string
  textType?: string
  type?: string
  className?: any
  onClick?: Function
}

const DpTagTheme = (props: PropsType) => {
  const { children, bgType, textType, type, ...resProps } = props
  return (
    <div
      {...resProps}
      className={classnames({
        [styles['dp-tag-theme']]: true,
        [styles[`dp-tag-theme--${type}`]]: type,
        [styles[`dp-tag-theme--bg-${bgType}`]]: bgType,
        [styles[`dp-tag-theme--text-${textType}`]]: textType,
      }, props?.className)}
    >{children}</div>
  )
}

export default DpTagTheme
